<template>
  <div class="feedback-complete-container">
    <h4>{{ $t('thanks-header') }}</h4>
    <p>{{ $t('thanks-description') }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped>
.feedback-complete-container {
  text-align: center;
}
</style>
